/**
 * txnFormat — pure, dependency-free formatters for the Transactions report
 * (FEAT-ANALYTICS-002). Kept out of components.jsx so they're unit-testable
 * without pulling Chakra/Highcharts into the jest transform.
 */

// Money — compact, currency-agnostic (tenants carry their own currency codes).
// Large sums abbreviate (1.2M / 34.5K) so KPI tiles stay legible; a code prefix
// (e.g. "PKR") is shown when the data carries a single consistent currency.
export const fmtMoney = (n, code) => {
  const v = Number(n || 0);
  const abs = Math.abs(v);
  const num = abs >= 1e6 ? `${(v / 1e6).toFixed(2)}M`
    : abs >= 1e3 ? `${(v / 1e3).toFixed(1)}K`
    : v.toLocaleString(undefined, { maximumFractionDigits: 2 });
  return code ? `${code} ${num}` : num;
};

// Single consistent currency code across rows, else '' (mixed-currency tenants).
export function soleCurrency(rows = []) {
  const codes = [...new Set(rows.map((r) => r.currency).filter(Boolean))];
  return codes.length === 1 ? codes[0] : '';
}

// Human time for a ClickHouse datetime; blank/unparseable inputs degrade safely.
export function fmtWhen(s) {
  if (!s) return '';
  const d = new Date(String(s).replace(' ', 'T'));
  if (isNaN(d)) return String(s).slice(0, 16);
  return d.toLocaleString(undefined, { month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' });
}
